import { render, staticRenderFns } from "./EmailField.vue?vue&type=template&id=ef8de0d8"
import script from "./EmailField.vue?vue&type=script&lang=ts"
export * from "./EmailField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports